import axios from 'axios';


export const insertOrUpdateCustomers = (form) => async dispatch => {
  const res = await axios.post('/api/insertOrUpdateCustomers',{form:form});
  return res.data;
}
export const searchCustomers = (info) => async dispatch => {
  const res = await axios.post('/api/searchCustomers',{info:info});
  return res.data;
}
export const getCustomersListByString = (stringList) => async dispatch => {
  const res = await axios.post('/api/getCustomersListByString',{stringList:stringList});
  return res.data;
}
export const sendMassageFromServer = (info) => async dispatch => {
  const res = await axios.post('/api/sendMassageFromServer',{info:info});
  return res.data;
}
export const updateCustomerInfo = (info) => async dispatch => {
  const res = await axios.post('/api/updateCustomerInfo',info);
  return res.data;
}
export const getCusHistory = (id) => async dispatch => {
  const res = await axios.post('/api/getCusHistory',{id:id});
  return res.data;
}
export const getCustomerEmailHistory = (id) => async dispatch => {
  const res = await axios.get('/api/customers/' + id + '/email-history');
  return res.data;
}
export const getCusTagsByMailOrPhone = (phone,mail) => async dispatch => {
  const res = await axios.post('/api/getCusTagsByMailOrPhone',{mail,phone});
  return res.data;
}
